import React from 'react'
import ReactDOM from 'react-dom'

const DeliveryStore = ({ store, data, handleChangeStore }) => {
    return <div className="happy-order__delivery-store">
        <div className={ `happy-order__delivery-store-radio${ (data.delivery.store_id == store.ID) ? ' happy-order__delivery-store-radio_active' : '' }` }>
            <div className="radio">
                <input
                    name="order-store"
                    id={ `order-store-${ store.ID }` }
                    type="radio"
                    value={ store.ID }
                    onChange={ handleChangeStore.bind(this, store) }
                    checked={ (data.delivery.store_id == store.ID) ? true : false }
                />
                <label htmlFor={ `order-store-${ store.ID }` }>
                    <span dangerouslySetInnerHTML={ { __html : store.TITLE } }></span>
                    
                    <div className="order-store__label">
                        Адрес:
                    </div>
                    <div
                        className="order-store__text"
                        dangerouslySetInnerHTML={ { __html : store.ADDRESS } }
                    />

                    <div className="order-store__label">
                        Магазин работает:
                    </div>
                    <div
                        className="order-store__text"
                        dangerouslySetInnerHTML={ { __html : store.SCHEDULE } }
                    />
                </label>
            </div>
        </div>
    </div>
}

export default DeliveryStore